export const tipos = [
  {
    text: "Todos",
    valor: null,
    id: "todos",
    //icon: icon_nasc,
    disabled: false
  },
  {
    text: "CRC",
    valor: "CARGA",
    id: "crc",
    //icon: icon_nasc,
    disabled: false
  },
  {
    text: "Sofia",
    valor: "SOFIA",
    id: "sofia",
    //icon: icon_nasc,
    disabled: true
  },
  {
    text: "Seade",
    valor: "SEADE",
    id: "seade",
    //icon: icon_nasc,
    disabled: true
  },
]

export const acoes = [
  {
    label: "Todos",
    belongs: [null, "CARGA"],
    value: null,
    show: true
  },
  {
    label: "Envio de Registro à CRC (Carga)",
    belongs: [null, "CARGA"],
    value: "INCLUSAO",
    show: true
  },
  {
    label: "Anotação (Interno)",
    belongs: [null, "SOFIA"],
    value: 2,
    show: false
  },
  {
    label: "Comunicação à Cartório",
    belongs: [null, "CARGA"],
    value: 3,
    show: false
  },
  {
    label: "Alteração de Registro",
    belongs: [null, "CARGA"],
    value: "ALTERACAO",
    show: true
  },
  {
    label: "Exclusão de Registro",
    belongs: [1, 2],
    value: 5,
    show: false
  },
  {
    label: "Cancelamento de Registro",
    belongs: [null, "CARGA"],
    value: 6,
    show: false
  },
  {
    label: "Retirar da Consulta Externa",
    belongs: [null, "CARGA"],
    value: 7,
    show: false
  },
  {
    label: "SEADE",
    belongs: [null, "SEADE"],
    value: 8,
    show: false
  },
  {
    label: "e-Habilitações em curso",
    belongs: [null, "SOFIA"],
    value: 9,
    show: false
  },
  {
    label: "Preparação Casamento",
    belongs: [null, "SOFIA"],
    value: 10,
    show: false
  },
]
